<template>
    <div v-if="mission && (mission.status === 'PENDING' || mission.status === 'ONGOING')">
        <label class="form-label d-block w-100 text-center">
            <h6 v-if="mission.status === 'PENDING'" class="d-flex justify-content-center align-items-center gap-2">
                Commentaire départ
                <span class="badge rounded-pill" :class="statusBadgeClass" :title="statusBadgeTitle">
                    {{ statusBadgeText }}
                </span>
            </h6>
            <h6 v-else class="d-flex justify-content-center align-items-center gap-2">
                Commentaire fin
                <span class="badge rounded-pill" :class="statusBadgeClass" :title="statusBadgeTitle">
                    {{ statusBadgeText }}
                </span>
            </h6>
        </label>

        <select class="form-select mt-3" :disabled="disabled" :value="model" @change="onChange">
            <option disabled value="">— Sélectionnez un commentaire —</option>
            <option v-for="opt in optionsList" :key="opt" :value="opt">
                {{ opt }}
            </option>
        </select>

    </div>
    <!-- FINISHED (ou autre) => rien -->
    <div v-else />
</template>

<script>
const DEFAULT_START_OPTIONS = [
    "Rien à signaler.",
    "Problème dans les tests d'avant mission, démarrage autorisé par le client."
];

const DEFAULT_END_OPTIONS = [
    "Rien à signaler.",
    "Itinéraire modifié suite à problème sur le trajet initial."
];

export default {
    name: "MissionCommentPicker",
    props: {
        mission: { type: Object, required: true },
        disabled: { type: Boolean, default: false }
    },
    emits: ["startCommentChange", "endCommentChange"],
    data() {
        return {
            startLocal: "",
            endLocal: ""
        };
    },
    computed: {
        optionsList() {
            return this.mission?.status === "PENDING"
                ? DEFAULT_START_OPTIONS
                : DEFAULT_END_OPTIONS;
        },
        model() {
            return this.mission?.status === "PENDING"
                ? this.startLocal
                : this.endLocal;
        },
        hasSelection() {
            return !!(this.model && this.model.trim());
        },
        statusBadgeClass() {
            return this.hasSelection ? 'bg-success' : 'bg-warning text-dark';
        },
        statusBadgeText() {
            return this.hasSelection ? 'Sélectionné' : 'À sélectionner';
        },
        statusBadgeTitle() {
            if (this.hasSelection) {
                return this.mission?.status === 'PENDING'
                    ? `Commentaire de départ sélectionné${this.model ? ' : ' + this.model : ''}`
                    : `Commentaire de fin sélectionné${this.model ? ' : ' + this.model : ''}`;
            }
            return this.mission?.status === 'PENDING'
                ? 'Sélectionnez un commentaire de départ.'
                : 'Sélectionnez un commentaire de fin.';
        }
    },
    methods: {
        onChange(e) {
            const val = e.target.value;
            if (this.mission?.status === "PENDING") {
                this.startLocal = val;
                this.$emit("startCommentChange", val);
            } else if (this.mission?.status === "ONGOING") {
                this.endLocal = val;
                this.$emit("endCommentChange", val);
            }
        }
    }
};
</script>
